import { Multiples } from "../../SIprefixe";
import { Unit, UnitBaseTypes } from "../../Units";

function Megapascal() {
  return <Unit unit={UnitBaseTypes.pascal} prefix={Multiples.mega} />;
}

export default Megapascal;
